export enum CommunicationsResponseGetVoiceDeviceTokenError {}
